'use client';

import type { Country } from '@eliadmin/core/src/api/general/types/general-types';
import {
  AddressFields,
  BILLING_FIELDS,
} from '@eliadmin/core/src/components/dlz/auth/register/address-fields';
import { REGISTER_COPY } from '@eliadmin/core/src/components/dlz/auth/register/register-copy';
import { RegisterCard } from '@eliadmin/core/src/components/dlz/auth/register/register-card';
import { CheckboxField } from '@eliadmin/core/src/components/dlz/auth/register/register-fields';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/** Figma „Fakturačná adresa“ (60260:28443): optional billing address and the „iná adresa“ switch. */
export function BillingCard({ countries }: { countries: Country[] }) {
  const { t } = useTranslations();

  return (
    <RegisterCard title={t('text45')} hint={REGISTER_COPY.billing.hint} spacing="compact">
      <AddressFields fields={BILLING_FIELDS} countries={countries} autoCompletePrefix="billing " />
      <CheckboxField name="different_delivery_address" className="mt-2">
        {REGISTER_COPY.billing.otherDelivery}
      </CheckboxField>
    </RegisterCard>
  );
}
